import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "mt-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.personId) = $event)),
      type: "text",
      placeholder: "PersonID"
    }, null, 512), [
      [_vModelText, $setup.personId]
    ]),
    _hoisted_1,
    _createElementVNode("button", {
      class: "btn btn-primary mt-20",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.createUser && $setup.createUser(...args)))
    }, "Create User"),
    ($setup.responseMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($setup.responseMessage), 1))
      : _createCommentVNode("", true)
  ]))
}